const processtMixin = {
  data () {
    return {
      commentVisible: false,
      approvalCommentHistory: [],
      currentNodeId: '',
      approvalInstanceId: '',
      // 是否开启了已办查看限制（为晟融租户专用）
      checkRestrict: false
    }
  },
  methods: {
    stateView (row) {
      this.currentNodeId = row.nodeId
      this.$axios.get(`/process-api/runtime/dealRecord?taskId=${row.id}`).then((res) => {
        this.approvalCommentHistory = res.data
        if (res.data && res.data.length) {
          this.checkRestrict = !!res.data[0].checkRestrict
        }
        this.commentVisible = true
        this.approvalInstanceId = row.id
      })
    }
  }
}
const processViewMixin = {
  data () {
    return {
      formRuntimeDialog: {
        visible: false,
        instanceId: '',
        width: '',
        title: '查看',
        type: 'process-view',
        currentNodeId: ''
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'process-view') {
      this.formRuntimeDialog.type = 'process-view'
      this.formRuntimeDialog.instanceId = to.params.instanceId
      this.formRuntimeDialog.currentNodeId = to.params.currentNodeId
      this.formRuntimeDialog.nodeId = to.params.nodeId
      this.$axios.get(`/process-api/runtime/processView/${to.params.instanceId}`).then((res) => {
        this.formRuntimeDialog.width = JSON.parse(res.data.component.properties).formScreen || 'full'
        this.formRuntimeDialog.visible = true
      })
    } else {
      next()
    }
  }
}

// 分组导航方法
const processNavMixin = {
  data () {
    return {
      groupNavDefinition: false,
      showGroupNav: false,
      oldGroupComponent: null
    }
  },
  computed: {
    groupComponent () {
      return this.getGroupComponent(this.getComponent)
    }
  },
  methods: {
    // 当前标签页的分组控件
    getCurrentgroupComponent (id) {
      let currentComponent = this.getComponent.find(m => m.id === id)
      return this.getGroupComponent([currentComponent])
    },
    // 顺序找到所有分组控件
    getGroupComponent (arr, groupArray = []) {
      arr.forEach(e => {
        if (e.componentType && e.componentType === 'rc-group' && e.properties && !e.properties.hidden && !e.properties.NIHidden) {
          groupArray.push(e)
        }
        if (e.children && e.children.length > 0) {
          this.getGroupComponent(e.children, groupArray)
        }
      })
      return groupArray
    },
    getProcessGroupNav () {
      // 开启了分组导航并且有分组控件才会展示
      if (this.groupComponent.length > 0 && this.groupNavDefinition) {
        this.showGroupNav = true
      } else {
        this.showGroupNav = false
      }
      this.initStateObj.showGroupNav = this.showGroupNav
    },
    // 导航到分组
    navToGroup (tabpane) {
      let currentGroupComponent = this.nodeTabEnable ? this.getCurrentgroupComponent(this.nodeTab.activeName)[tabpane.index] : this.groupComponent[tabpane.index]
      let currentGroupInstance = this.findVueByComponentId(currentGroupComponent.id)
      // 之前选中的分组控件取消高亮
      if (this.oldGroupComponent && currentGroupInstance && this.oldGroupComponent.component.id !== currentGroupInstance.component.id) {
        this.oldGroupComponent.remind = false
      }
      this.oldGroupComponent = currentGroupInstance
      if (currentGroupInstance) {
        // 高亮并展开当前导航到的分组
        currentGroupInstance.remind = true
        currentGroupInstance.fold = false
        this.$nextTick(() => {
          if (this.nodeTabEnable) {
            let index = this.getHasComponentNode ? this.getHasComponentNode.findIndex(n => n.id === this.nodeTab.activeName) : this.getComponent.findIndex(n => n.id === this.nodeTab.activeName)
            this.$refs.form[index].$parent.$el.parentElement.scrollTo(0, currentGroupInstance.$el.offsetTop - 60)
          } else {
            this.$refs.formStyle.scrollTo(0, currentGroupInstance.$el.offsetTop - 60)
          }
        })
      }
    }
  },
  beforeDestroy () {
    this.oldGroupComponent = null
  }
}

const processNodeInteraction = {
  provide () {
    return {
      currentNodeInteractions: this.currentNodeInteractions,
      currentNode: {currentNodeId: ''}
    }
  },
  data () {
    return {
      currentNodeInteractions: []
    }
  },
  methods: {
    // 处理节点交互数据, 将同一节点的要处理从控件/节点归到一类
    handleProcessNodeInteraction (nodeInteractions) {
      nodeInteractions = JSON.parse(nodeInteractions)
      let currentNodeInteractions = []
      nodeInteractions.forEach(e => {
        e.nodeIds.forEach(nodeId => {
          // 如果新的数组里找不到这个节点则加进去并加入这个节点要操作的控件
          let nodeInt = currentNodeInteractions.find(e => e.nodeId === nodeId)
          if (!nodeInt) {
            currentNodeInteractions.push({nodeId: nodeId, components: e.components})
          } else {
            // 如果能找到则拼接这个节点要操作的组件
            nodeInt.components = this.$_.uniq([...[nodeInt.components], ...e.components])
          }
        })
      })
      this.currentNodeInteractions = currentNodeInteractions
      this._provided.currentNode.currentNodeId = this.currentNodeId || this.nodeId
      this._provided.currentNodeInteractions = this.currentNodeInteractions
    },
    /**
     * @param {Array} components 当前节点要展示的所有组件
     * @param {String} currentNodeId 当前节点Id
     * */
    updateFormNodeInteractions (components, currentNodeId) {
      // 每一层都由其父级处理而不使用递归, 防止在计算属性中重复的大量运算
      // 第一层对选择了节点进行处理, 节点的控件值用的表单id, 所以仍然只需要对控件进行判断
      components.forEach(component => {
        let currentNIComponents = this.currentNodeInteractions.find(e => e.nodeId === currentNodeId)
        // 如果当前节点存在节点交互 && 当前节点交互的控件中包含该控件 则给表单和其下的分组控件打上隐藏标记. 因为分组控件隐藏时需要在分组导航中不展示
        if (currentNIComponents && component.id && currentNIComponents.components.includes(component.id)) {
          component.properties.hidden = true
          if (component.children.length > 0) {
            component.children.forEach(c => {
              if (c.componentType === 'rc-group') {
                c.properties.NIHidden = true
              }
            })
          }
        }
      })
      return components
    },
    hiddenForm (item) {
      if (item) {
        item.children.forEach(n => {
          // 分组内的控件显示隐藏得和分组一致
          if (n.componentType === 'rc-group' && n.properties.hidden) {
            n.archivedChildren.forEach(el => {
              el.properties.hidden = n.properties.hidden
            })
          }
        })
        item.recursionGetComponents()
        let component = item.find(m => {
          return m.componentType !== 'rc-draggable' && m.componentType !== 'rc-layout' && m.componentType !== 'rc-form' && m.componentType !== 'rc-group' && !m.properties.hidden
        })
        if ((component === undefined || item.properties.hidden) && document.querySelector(`#tab-${item.id}`)) {
          document.querySelector(`#tab-${item.id}`).style.display = 'none'
        }
        return component !== undefined
      } else {
        return false
      }
    }
  }
}
export {processtMixin, processViewMixin, processNavMixin, processNodeInteraction}



// WEBPACK FOOTER //
// ./src/components/process/runtime/mixin.js